import { QRCode } from "react-qrcode-logo";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faEnvelope, faMapMarkerAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { fetchSubmissionByRef } from "../../api/Submission";
import { formatDate } from "../../util/date";
import { useNavigate } from "react-router-dom";

const formatSchedules = (schedules = []) => {
  if (schedules.length === 1) {
    return formatDate(schedules[0].date);
  }

  const firstDay = schedules[0].date;
  const lastDay = schedules.at(-1).date;

  return `${formatDate(firstDay)} - ${formatDate(lastDay)}`;
};

const SubmissionPage = () => {
  const navigate = useNavigate();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const refLink = urlParams.get('refId');
  const [submissionData, setSubmissionData] = useState({});

  const { personal_name, last_name, start_date, end_date, venue, event_name, email, schedules } = submissionData;

  const retrieveSubmission = async () => {
    const res = await fetchSubmissionByRef(refLink);

    setSubmissionData(res);
  };

  useEffect(() => {
    retrieveSubmission();

    const userData = localStorage.getItem("user-data");

    if (userData) {
      const parsedData = JSON.parse(userData);

      if (parsedData?.authenticated) {
        navigate("/ems/dashboard/events?submissionId=" + refLink);
      }
    }
  }, []);

  return (
    <>
      {submissionData.id_attendee && (
        <div className="submission__wrapper">
          <div className="submission__container">
            <div className="submission__qrcode--container">
              <QRCode value={window.location.href} />
            </div>
    
            <div className="submission__details--container">
              <div className="submission__details--section">
                <div className="submission__details--header">
                  Participant Details
                </div>
    
                <div className="submission__details--line">
                  <div className="submission__details--icon">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                  <div className="submission__details--text">
                    {personal_name} {last_name}
                  </div>
                </div>
                
                <div className="submission__details--line">
                  <div className="submission__details--icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="submission__details--text">
                    {email}
                  </div>
                </div>
              </div>
    
              <div className="submission__details--section">
                <div className="submission__details--header">
                  Event Details
                </div>
    
                <div className="submission__details--line">
                  <div className="submission__details--text bold">
                    {event_name}
                  </div>
                </div>
                
                <div className="submission__details--line">
                  <div className="submission__details--icon">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </div>
                  <div className="submission__details--text">
                    {schedules && formatSchedules(schedules)}
                  </div>
                </div>
                
                <div className="submission__details--line">
                  <div className="submission__details--icon">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>
                  <div className="submission__details--text">
                    {venue}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubmissionPage;